import $ from 'jquery';
import Backbone from 'backbone';

const Document = Backbone.Model.extend({
  save() {
    var formData = new FormData();
    formData.append('name', this.get('name'));
    formData.append('description', this.get('description'));
    formData.append('url', this.get('file'));

    var self = this;
    return $.ajax({
      url: '/joinos/api/documents?format=json',
      method: 'POST',
      data: formData,
      processData: false,
      contentType: false
    }).success(function (rsp) {
      self.set(rsp);
    });
  }
});

module.exports = Document;



// WEBPACK FOOTER //
// ./base/models/document.js